<template>
  <Tag
    v-if="isFromSrfLite"
    unstyled
    class="tag tag-secondary uppercase"
    :class="wrapperClass"
    :value="tagValue"
  />
</template>

<script>
import Tag from "primevue/tag"
import { IssuerId } from "@/components/srf-lite/Types"

export default {
  name: "AmcIndicator",
  components: {
    Tag
  },
  props: {
    isFromSrfLite: {
      type: Boolean,
      default: false
    },
    assetManagerId: {
      type: Number,
      default: null
    },
    wrapperClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    isLuma() {
      return this.assetManagerId === 762
    },
    isAmcForPm() {
      return this.assetManagerId === IssuerId.Expand2Issuer
    },
    tagValue() {
      if (this.isLuma) {
        return "LUMA"
      }
      if (this.isAmcForPm) {
        return "AMC BANKABLE"
      }
      return "AMC FOR BANKS"
    }
  }
}
</script>
